import React, { useState, useEffect } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";
import { sweetConfirm } from "../utils/sweetAlerts";

function District() {

  const API = "";

  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);

  const [stateId, setStateId] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");

  // 🔥 LOAD STATES
  const fetchStates = () => {
    axios.get(`${API}/api/states`)
      .then(res => setStates(res.data));
  };

  // 🔥 LOAD DISTRICTS
  const fetchDistricts = () => {
    axios.get(`${API}/api/districts`)
      .then(res => setDistricts(res.data));
  };

  useEffect(() => {
    fetchStates();
    fetchDistricts();
  }, []);

  // 🔥 ADD DISTRICT
  const addDistrict = async () => {

    if (!stateId || !name || !code) {
      return alert("All fields required");
    }

    await axios.post(`${API}/api/districts`, {
      state_id: stateId,
      name,
      code
    });

    setName("");
    setCode("");
    setStateId("");

    fetchDistricts();
  };

  // 🔥 DELETE
  const deleteDistrict = async (id) => {
    if (!(await sweetConfirm("Delete this district?", { confirmButtonText: "Yes, Delete" }))) return;

    await axios.delete(`${API}/api/districts/${id}`);
    fetchDistricts();
  };

  return (
    <DashboardLayout>

      <div className="container-fluid">

        <h3 className="mb-4">District Management</h3>

        {/* 🔥 FORM */}
        <div className="row mb-3">

          {/* STATE SELECT */}
          <div className="col-md-3">
            <select
              className="form-control"
              value={stateId}
              onChange={(e) => setStateId(e.target.value)}
            >
              <option value="">Select State</option>
              {states.map(s => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          {/* DISTRICT NAME */}
          <div className="col-md-3">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="District Name"
              className="form-control"
            />
          </div>

          {/* DISTRICT CODE */}
          <div className="col-md-2">
            <input
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="District Code"
              className="form-control"
            />
          </div>

          {/* BUTTON */}
          <div className="col-md-2">
            <button onClick={addDistrict} className="btn btn-success w-100">
              Add District
            </button>
          </div>

        </div>

        {/* 🔥 TABLE */}
        <table className="table table-bordered table-striped">

          <thead>
            <tr>
              <th>State</th>
              <th>District</th>
              <th>Code</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {districts.map(d => (
              <tr key={d.id}>
                <td>{d.state_name}</td>
                <td>{d.name}</td>
                <td>{d.code}</td>
                <td>
                  <button
                    onClick={() => deleteDistrict(d.id)}
                    className="btn btn-danger btn-sm"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>

        </table>

      </div>

    </DashboardLayout>
  );
}

export default District;
